import { MANIFESTO } from "@/data";
import Reveal from "@/components/Reveal";

export default function Manifesto() {
  return (
    <section id="about" className="relative bg-ink py-28 md:py-40" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <span className="overline">[ Who we are ]</span>
              <h2 className="mt-6 font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                The <span className="text-purple">Ground</span>
                <br />
                <span className="text-lime">Crew.</span>
              </h2>
              <p className="mt-8 text-white/60 text-base md:text-lg max-w-md font-body">
                Aero Detail Lab Ltd was founded by Balraj Panesar and co-founder Justin Gill.
                As BCIT-trained Aircraft Maintenance Engineers specializing in Avionics, both
                bring a strong background in general aviation to the detailing industry. Built
                on a maintenance and regulations-first mindset, we approach aircraft detailing
                with the same discipline and situational awareness as aviation maintenance. We
                don&apos;t just care about how a plane looks on the ramp. We understand how every
                chemical, surface treatment, and material interacts with the aircraft.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="border-t border-white/10">
              {MANIFESTO.map((m, i) => (
                <Reveal key={m.n} delay={i * 0.08}>
                  <div className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 border-b border-white/10 transition-colors duration-500 hover:bg-surface/60 px-2 md:px-6">
                    <img src="/plane-jet.png?v=3" alt="" className="w-16 md:w-20 h-auto object-contain mt-2 shrink-0" />
                    <div>
                      <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-purple group-hover:translate-x-2 transition-transform duration-500">
                        {m.title}
                      </h3>
                      <p className="mt-3 text-white/55 text-base max-w-lg font-body">{m.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
